import { useLocation } from 'react-router-dom';
import HeaderComponent from '../Components/Header/HeaderComponent';
import RouterX from '../Router/RouterX';
import './LayoutX.scss';

const LayoutX = () => {
  let location = useLocation();
  console.log(location);
  return (
    <>
      {!location?.pathname?.includes('/quotation') && <HeaderComponent />}
      <RouterX />
    </>
  );
};
export default LayoutX;
